
















































import Enumerable from "linq";
import { Mixins, Component } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../components/system";
import { FormatStructureEditableMixin, CommonComponentsAccessibleMixin } from "../../mixins";
import { IFormatAlert } from "../../../../../domain/editableFormat/IFormatAlert";

@Component
export default class FormatAlertTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin, CommonComponentsAccessibleMixin) {
  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }

  validate(): void {
    const validator = this.getCommonComponents().getOperators().getValidator();
    validator.validate(false)
    .then(result => {
      this.alerts = validator.alerts;
      const count = Enumerable.from(this.alerts).where(s => s.isError).count();
      if (result) {
        this.$success("確認結果", "登録可能です。(警告件数:" + count + ")");
      } else {
        this.$warn("確認結果", "登録できません。(警告件数:" + count + ")");
      }
    })
    .catch(e => {
      this.$warn("警告", "警告処理中にエラーが発生しました。", e);
    });
  }

  click(row: IFormatAlert) {
    if (!row.detectedObject) { return; }
    this.updateFocusedObject(row.detectedObject);
  }
}
